import { render, staticRenderFns } from "./ApexChartMobileComparison.vue?vue&type=template&id=73204674&"
import script from "./ApexChartMobileComparison.vue?vue&type=script&lang=js&"
export * from "./ApexChartMobileComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports